// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failedMcqModal .ant-modal {
  position: fixed;
}

.failedMcqModal .ant-modal.zoom-leave-active,
.failedMcqModal .ant-modal.zoom-leave,
.failedMcqModal .ant-modal-footer {
  display: none;
}

.failedMcqModal.failedMcqModal-centered .ant-modal {
  position: relative;
}

.failedMcqModal .ant-modal-content {
  border-bottom: 4px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(90deg, #4E61C2 0%, #2E76D4 100%);
  min-height: 248px;
  max-width: 500px;
}

.failedMcqModal .infoIcon {
  padding-right: 30px;
}
.failedMcqModal .helpTitle {
  font-weight: 500;
  font-size: 20px;
}
.failedMcqModal .helpSubTitle {
  font-size: 16px;
  margin-bottom: 20px;
}
.failedMcqModal .helpTipWrapper {
  display: flex;
  align-items: flex-start;
}
.failedMcqModal .helpTipWrapper img {
  margin-right: 10px;
  object-fit: contain;
  padding-top: 1px;
}
.failedMcqModal .helpTip {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/tests/Modals/FailedMCQ.modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,qEAAqE;EACrE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB","sourcesContent":[".failedMcqModal .ant-modal {\n  position: fixed;\n}\n\n.failedMcqModal .ant-modal.zoom-leave-active,\n.failedMcqModal .ant-modal.zoom-leave,\n.failedMcqModal .ant-modal-footer {\n  display: none;\n}\n\n.failedMcqModal.failedMcqModal-centered .ant-modal {\n  position: relative;\n}\n\n.failedMcqModal .ant-modal-content {\n  border-bottom: 4px solid;\n  border-image-slice: 1;\n  border-width: 5px;\n  border-image-source: linear-gradient(90deg, #4E61C2 0%, #2E76D4 100%);\n  min-height: 248px;\n  max-width: 500px;\n}\n\n.failedMcqModal .infoIcon {\n  padding-right: 30px;\n}\n.failedMcqModal .helpTitle {\n  font-weight: 500;\n  font-size: 20px;\n}\n.failedMcqModal .helpSubTitle {\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n.failedMcqModal .helpTipWrapper {\n  display: flex;\n  align-items: flex-start;\n}\n.failedMcqModal .helpTipWrapper img {\n  margin-right: 10px;\n  object-fit: contain;\n  padding-top: 1px;\n}\n.failedMcqModal .helpTip {\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
